/** The company's website as homeowners click it (calculator, quote page, emails): only http(s) links. */

/** A web link the API accepts (`BrandContact.url`). */
export function isWebLink(value: string): boolean {
  return /^https?:\/\/\S+$/.test(value);
}

/** "www.sunny.com" or "sunny.com/contact" becomes "https://…"; anything else stays as typed (and is then refused). */
export function websiteLink(value: string): string {
  const v = value.trim();
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+(\/\S*)?$/i.test(v) ? `https://${v}` : v;
}
